function findAncestor (el, cls) {
  while ((el = el.parentElement) && !el.classList.contains(cls));
  return el;
}

class fabricSamples {
  constructor() {
    this.selectedItems = [];
    this.items = document.querySelectorAll('.selected-item');
    this.container = document.getElementById('custom-options');
    this.options = document.querySelectorAll('.custom-option');
    this.disabledBtns = document.querySelectorAll('.product-form__btn_disabled');
    this.clearAllBtn = document.querySelector('.selected-clear');
    this.selectedQty = document.querySelector('.selected-qty .qty');
    this.initEvents();
  }

  initEvents() {
    this.options.forEach((option) =>
      option.addEventListener('click', this.checkOption.bind(this))
    );
    this.disabledBtns.forEach((btn) =>
      btn.addEventListener('click', this.checkRequiredBtn.bind(this))
    );
    this.clearAllBtn.addEventListener('click', this.clearItems.bind(this));
    this.items.forEach((item) =>
      item.addEventListener('click', this.removeItem.bind(this))
    );
    this.stickyBtn();
  };

  checkOption(event) {
    event.preventDefault();
    let option = event.currentTarget;
    if (!option.classList.contains('selected')) {
      if (document.querySelectorAll('.custom-option.selected').length < 12) {
        let option_name = option.getAttribute('data-name');
        this.selectedItems.push(option_name);
        option.classList.add('selected');
        option.querySelectorAll('input').forEach(el=>el.checked = true);
      }
    } else {
      option.classList.remove('selected');
      option.querySelectorAll('input').forEach(el=>el.checked = false);
      let option_name = option.getAttribute('data-name');
      this.selectedItems = this.selectedItems.filter(function(item) {
        return item !== option_name
      })
    }
    this.addValue();
  };

  addValue(){
    document.querySelectorAll('.selected-items .selected-item-title').forEach(item=> item.innerHTML = '' );
    if(document.querySelectorAll('.selected-item.selected')){
      document.querySelectorAll('.selected-item.selected').forEach(item=> item.classList.remove('selected'));
    }
    this.selectedItems.forEach((option, i)  => {
      document.querySelector('.selected-item-'+ (i+1)).classList.add('selected');
      document.querySelector('.selected-item-'+ (i+1) + ' .selected-item-title').innerHTML = option;
      let curOption = document.querySelector('.custom-option[data-name="'+ option +'"] .option-data');
      let option_inputs = `
      <input class='hidden' name='properties[${curOption.getAttribute('data-property-name')}[${i}]]' type='radio' id='radioButton-${i}' value='${option}' checked>
      <input class='hidden' name='properties[_option_${curOption.getAttribute('data-property-id')}[${i}]]' id='radioButtonId-${i}' type='radio' value='${curOption.getAttribute('data-id')}' checked>`
      document.querySelector('.selected-item-'+ (i+1) + ' .selected-option').innerHTML = option_inputs;
    });
    this.selectedQty.innerHTML = this.selectedItems.length;

    this.checkRequired();
  };

  removeItem(event){
    if (event.currentTarget.classList.contains('selected')){
      let item_index = +event.currentTarget.getAttribute('data-index') - 1;
      document.querySelector('.custom-option[data-name="'+ this.selectedItems[item_index] +'"]').classList.remove('selected');
      document.querySelector('.custom-option[data-name="'+ this.selectedItems[item_index] +'"]').querySelectorAll('input').forEach(el=>el.checked = false);
      this.selectedItems.splice(item_index, 1);
      this.addValue();
    }
  };

  clearItems(){
    document.querySelectorAll('.selected-items .selected-item-title').forEach(item=> item.innerHTML = '' );
    if(document.querySelectorAll('.selected-item.selected')){
      document.querySelectorAll('.selected-item.selected').forEach(item=> item.classList.remove('selected') );
    }
    document.querySelectorAll('.custom-option.selected').forEach(option  => option.classList.remove('selected'));
    document.querySelectorAll('.custom-option.selected').forEach(option  => option.querySelectorAll('input').forEach(el=>el.checked = false));
    this.selectedQty.innerHTML = '';
    this.selectedItems = [];
    this.checkRequired();
  };

  checkRequiredBtn(event){
    event.preventDefault();
    event.stopPropagation();
    let btn = event.currentTarget;
    btn.parentElement.classList.add("error");
    btn.innerHTML = "make a seleсtion";
    if(document.querySelector('.product-form__buttons.fixed')){
      let sticky_header = 0;
      let option_block = findAncestor (btn, 'selected-variants');
      if(document.querySelector('.sticky-header')){
        sticky_header = +document.querySelector('.header-wrapper').offsetHeight;
      }
      window.scrollTo({top: (option_block.offsetTop - sticky_header - 20 ) , behavior: 'smooth'});
    }
  };

  checkRequired(){
    document.querySelectorAll('.product-form__btn_disabled').forEach(el=>el.innerHTML = '');
    if(this.selectedItems.length >= 4){
      document.querySelectorAll('.product-form__btn').forEach(el=>el.classList.remove("disabled", "error"));
    }else{
      document.querySelectorAll('.product-form__btn').forEach(el=>{el.classList.remove( "error"); el.classList.add( "disabled")});
    }
  };
  stickyBtn(){
    window.addEventListener('scroll',(event) => {
      let productAddBtn = document.querySelector('.product-form__submit');
      let productAddBtnMask = document.querySelector('.product-form__buttons .button-mask');
      let productAddBtnParent = findAncestor(productAddBtn, 'product-form__buttons');
      if(productAddBtn && productAddBtnParent){
        if(window.innerWidth < 990 ){
          if (window.scrollY > productAddBtn.parentElement.offsetTop) {
            if(document.querySelector('.sticky-header')){
              productAddBtn.style.top = (document.querySelector('.header-wrapper').offsetHeight - 1) + 'px';
              productAddBtnMask.style.top = (document.querySelector('.header-wrapper').offsetHeight - 1) + 'px';
            }
            productAddBtnParent.classList.add('fixed');
            productAddBtnParent.style.paddingBottom = productAddBtn.offsetHeight + 'px'
          } else {
            productAddBtn.style.top = '0px';
            productAddBtnMask.style.top = '0px';
            productAddBtnParent.style.paddingBottom = '0px';
            productAddBtnParent.classList.remove('fixed');
          }
        }else{
          productAddBtn.style.top = '0px';
          productAddBtnMask.style.top = '0px';
          productAddBtnParent.style.paddingBottom = '0px';
          productAddBtnParent.classList.remove('fixed');
        }
      }
    })
  }
}

document.addEventListener('click', e => {
  if (window.innerWidth > 989){
    let target = e.target;
    let filter = document.querySelector('.filter-field.active');
    if(filter){
      let its_filter = target == filter || filter.contains(target);
      if (!its_filter) {
        filter.classList.remove("active");
      }
    }
  }

});
var product_id;
var option_url;

document.addEventListener('DOMContentLoaded', function() {
  $('.filters-wrap-btn').on('click', function (ev){
    ev.preventDefault();
    $('.filters-block').addClass('active');
  });
  $('.filters-mob-header .filters-mob-close-btn, .filters-btn .filters-result').on('click', function (ev){
    ev.preventDefault();
    $('.filters-block').removeClass('active');
  });

  //GET OPTIONS
  product_id = document.querySelector('.product-wrap').getAttribute('data-product-id');
  product_type = document.querySelector('.product-wrap').getAttribute('data-product-type');
  option_url = "/apps/app-proxy/product-options/" + product_id;

  fetch(option_url, {
    method: "GET"
  })
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        this.handleErrorMessage(response.description);
        return;
      }
      createFiltes(response);
      createColors(response);
      new fabricSamples;
      document.querySelector('.custom-options').classList.add('active');
      document.querySelector('.product-spinner').classList.remove('active');
    })
});

// CREATE FABRIC BLOCK
function createColors(data){
  let obj = data;
  obj.options.forEach((element) => {
    if(element.option_show_type == "fabric"){
      let option_values = '';
      let value_id = element.option_id;
      let value_name = (element.display_name != '')? element.display_name : element.option_name;
      if(element.option_values){
        element.option_values.forEach((val, i) => {
          let input_val;
          let input_id;
          var image_elem = '';
          let create_date = new Date(val.updated_at.replace(/\-/g, '/'));
          let label = "<label class='check-option'>"+ val.name +"</label>"
          input_val = "<input class='hidden option-data' data-property-name='"+ value_name.replace(':', '') +"' data-id='"+ val.id +"' data-property-id='"+ value_id +"' id='radioButtonId-"+ val.id +"' type='radio' id='radioButton-"+ val.id +"' value=''>"
          if(val.image){
            image_elem = "<div class='option-image'><img src='"+ val.image +"'></div>";
          }
          option_values += "<div class='custom-option fabric' data-name='"+ val.name +"' data-index='"+ i +"' data-date='"+ create_date.getTime() +"' data-filtr-attrs='"+ val.filters.join(';') +"'>"+ image_elem + "<div class='option-val'>" + input_val + label + "</div></div>";
        });
      }
      if(option_values.length > 1){
        document.querySelector('.color-header .color-title').innerHTML = value_name;
        document.querySelector('.color-block-content').innerHTML = "<div class='option-block'>" + option_values + "</div>";
        document.querySelector('.color-block').classList.add("active");
      }
    }
  });
}

// FABRIC FILTERS

function createFiltes(data){
  let obj = data;
  let arrow = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="4px" height="9px" viewBox="0 0 4 9" version="1.1"><g id="UI-Design" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Homepage-(Tablet)" transform="translate(-691.000000, -6976.000000)" fill="#111111"><g id="Footer" transform="translate(0.000000, 6673.000000)"><g id="SHOPPING-Copy" transform="translate(56.000000, 283.000000)"><polygon id="Path-4-Copy-2" transform="translate(637.002747, 24.511819) rotate(-90.000000) translate(-637.002747, -24.511819) " points="632.490927 22.5090728 641.514566 22.5090728 636.945174 26.514566"/> </g></g></g></g></svg>';
  if(obj.filters.length > 0){
    let filter_field = '';
    obj.filters.forEach((filter) => {
      let filter_title = Object.keys(filter)[0];
      let filter_key = '';
      Object.values(filter)[0].forEach((value) => {
        filter_key += '<li class="filter-key" id="filter-value" title="'+ value +'" data-value="'+ value +'">'+ value +'</li>';
      });
      let filter_values = '<ul  class="filters-content" data-filter="'+ filter_title +'">'+ filter_key +'</ul>'
      filter_field += '<div class="filter-field"><div class="filter-title"><span>'+ filter_title +'<span class="filter-count"></span></span>'+ arrow +'</div>'+ filter_values +'</div>';
    });
    document.getElementById('filters_bar').innerHTML += filter_field;
    fabricFilter.init();
    $('.filters-mob-btn').addClass('show');
    $('.filters-block').addClass('show');
  }
};

fabricFilter = {
  coords: [],
  itemAttrs: [],
  eventHandles: [],
  origAttrStats: {},
  filterMappings: {},
  matched: '',
  init: function() {
    fabricFilter.itemList = $('.color-block-content');
    fabricFilter.filterWrap = $('.color-block');
    fabricFilter.attrGroups = fabricFilter.filterWrap.find('.filters-content');
    fabricFilter.placeholder = fabricFilter.filterWrap.find('.filter-title');
    fabricFilter.keys = fabricFilter.filterWrap.find('.filter-key');
    fabricFilter.sorts = fabricFilter.filterWrap.find('.sort-value');
    fabricFilter.clear_all_element = fabricFilter.filterWrap.find('.filt-clear');
    fabricFilter.filtersInited = false;
    fabricFilter.filtersFixed = false;
    fabricFilter.filtersExpanded = false;
    fabricFilter.initEvents();
    if (fabricFilter.keys.hasClass('selected')) {
      fabricFilter.initFilters();
    }
  },
  destruct: function() {
    for (var i = 0, j = fabricFilter.eventHandles.length; i < j; i++) {
      fabricFilter.eventHandles[i].unbind();
      fabricFilter.eventHandles[i] = null;
    }
    fabricFilter.coords = fabricFilter.itemAttrs = fabricFilter.eventHandles = fabricFilter.origAttrStats = fabricFilter.filterMappings = fabricFilter.tS = fabricFilter.viewportWidth = fabricFilter.layoutCon = fabricFilter.itemList = fabricFilter.filterWrap = fabricFilter.attrGroups = fabricFilter.placeholder = fabricFilter.keys = fabricFilter.has3dTransforms = fabricFilter.sortPrice = fabricFilter.items = fabricFilter.itemSize = fabricFilter.matched = fabricFilter.unmatched = fabricFilter.filtersInited = fabricFilter.filtersFixed = fabricFilter.filtersExpanded = null;
  },
  initFilters: function() {
    fabricFilter.sortPrice = fabricFilter.filterWrap.find('.filt-price-input');
    fabricFilter.items = fabricFilter.itemList.find('.custom-option');
    fabricFilter.showAll = true;
    fabricFilter.initItemAttrs();
    fabricFilter.initFilterMapping();
    fabricFilter.filtersInited = true;
  },
  initEvents: function() {
    fabricFilter.eventHandles[fabricFilter.eventHandles.length] = fabricFilter.placeholder.bind('click', fabricFilter.showFilterDropdown);
    fabricFilter.eventHandles[fabricFilter.eventHandles.length] = fabricFilter.clear_all_element.bind('click', fabricFilter.resetFilters);
    fabricFilter.eventHandles[fabricFilter.eventHandles.length] = fabricFilter.keys.bind('click', function() {
      if ($(this).hasClass('selected')) {
        $(this).removeClass('selected');
      }else{
        $(this).addClass('selected');
      }
      let f_count = $(this).closest(".filters-content").find('.filter-key.selected').length;
      if(f_count > 0){
        $(this).closest(".filter-field").find('.filter-count').text("("+ f_count +")");
      }else{
        $(this).closest(".filter-field").find('.filter-count').text("");
      }
      fabricFilter.filterAndDisplay();
    });
    fabricFilter.eventHandles[fabricFilter.eventHandles.length] = fabricFilter.sorts.bind('click', function(e) {
      e.preventDefault();
      fabricFilter.sorts.removeClass('selected');
      let date_type = $(this).data('value');
      $('.sort-value[data-value="'+ date_type +'"]').addClass('selected');
      fabricFilter.sortFilter(date_type);
      fabricFilter.initFilters();
      fabricFilter.filterAndDisplay();
      //new fabricSamples;
    });
  },
  initItemAttrs: function() {
    console.log('initItemAttrs');
    fabricFilter.items.each(function(index) {
      var attributes = [];
      if ($(this).attr('data-filtr-attrs')) {
        attributes = $(this).attr('data-filtr-attrs').split(';');
      }
      console.log(attributes);
      fabricFilter.itemAttrs[index] = attributes;
      fabricFilter.initAttrStats(attributes);
    });
  },
  initAttrStats: function(attr) {
    for (var i = 0, j = attr.length; i < j; i++) {
      fabricFilter.origAttrStats[attr[i]] = fabricFilter.origAttrStats[attr[i]] || 0;
      fabricFilter.origAttrStats[attr[i]]++;
    }
  },
  initFilterMapping: function() {
    $('.filt-item').each(function(i) {
      $(this).find('li').each(function(j) {
        var attr = $(this).attr('data-value');
        fabricFilter.filterMappings[attr] = i;
      });
    });
  },
  showFilterDropdown: function() {
    var selectCon;
    if (!fabricFilter.filtersInited) {
      fabricFilter.initFilters();
    }
    selectCon = $(this);
    if (selectCon.parent().hasClass('active')) {
      fabricFilter.hideFilterDropdown();
    } else {
      fabricFilter.hideFilterDropdown();
      selectCon.parent().addClass('active');
    }
  },
  hideFilterDropdown: function() {
    fabricFilter.filterWrap.find('.filter-field').removeClass('active');
  },
  togglePriceInputs: function(e) {
    fabricFilter.sortPrice.filter(':checked').each(function(input) {
      if (input !== e.target) {
        input.set('checked', false);
      }
    });
    fabricFilter.hideFilterDropdown();
    fabricFilter.filterAndDisplay();
  },
  onviewevent: function(e) {
    if (e.target.hasClass('filt-clear')) {
      fabricFilter.resetFilters();
      e.preventDefault();
      return false;
    }
    if (!e.target.ancestor('.filt-select-con')) {
      fabricFilter.hideFilterDropdown();
    }
  },
  sortFilter: function (type){
    if(type == 'default'){
      fabricFilter.items.sort(function(a,b) { return parseFloat(a.dataset.index) - parseFloat(b.dataset.index) } );
    }else if(type == 'new'){
      fabricFilter.items.sort(function(a,b) { return parseFloat(b.dataset.date) - parseFloat(a.dataset.date) } );
    }
    $('.color-block-content .option-block').html(fabricFilter.items);
  },
  filterAndDisplay: function() {
    var selectedArr = fabricFilter.parseFilters(),
      sortOrder;
    if (fabricFilter.showAll) {
      fabricFilter.resetItems();
    } else {
      fabricFilter.filterItems(selectedArr);
    }
    fabricFilter.hideItems(fabricFilter.unmatched);
    fabricFilter.displayItems(fabricFilter.matched);
    if (!fabricFilter.matched.length) {
      fabricFilter.showEmptyState();
    } else {
      fabricFilter.hideEmptyState();
    }
    fabricFilter.hideFilterDropdown();
    let filtered_item = fabricFilter.matched.length;
    if(filtered_item > 0){
      filtered_item = "See " + filtered_item;
    }
    $('.filters-result-numb').empty().append(filtered_item);
    $('.filters-result').addClass('active');
    if($('.filter-key.selected').length > 0){
      fabricFilter.clear_all_element.addClass('active');
    }else{
      fabricFilter.clear_all_element.removeClass('active');
    }
    let f_all_count = $('.filter-key.selected').length;
    if(f_all_count > 0){
      $('.filters-wrap-btn-numb').text("("+ f_all_count +")");
    }else{
      $('.filters-wrap-btn-numb').text("");
    }
    $('.loading-overlay').hide();
  },
  resetFilters: function(event) {
    event.preventDefault();
    fabricFilter.attrGroups.each(function(i) {
      $(this).find('.filter-key').removeClass('selected');
    });
    $('.filter-count').text("");
    fabricFilter.filterAndDisplay();
  },
  resetItems: function() {
    fabricFilter.matched = [];
    fabricFilter.unmatched = [];
    fabricFilter.items.each(function() {
      fabricFilter.matched.push($(this));
    });
  },
  filterItems: function(selectedArr) {
    var attrStats = $.extend(true, [], fabricFilter.origAttrStats),
      attrs;
    fabricFilter.matched = [];
    fabricFilter.unmatched = [];
    fabricFilter.items.each(function(i) {
      attrs = fabricFilter.itemAttrs[i];
      if (fabricFilter.filterAcrossGroups(attrs, selectedArr)) {
        fabricFilter.matched.push($(this));
      } else {
        fabricFilter.unmatched.push($(this));
      }
    });
  },
  filterAcrossGroups: function(attrs, selected) {
    var numMatched = 0;
    for (var i = 0, j = selected.length; i < j; i++) {
      if (fabricFilter.checkAnyMatch(attrs, selected[i])) {
        numMatched++;
      }
    }
    return numMatched === selected.length;
  },
  checkAnyMatch: function(attrs, selected) {
    for (var i = 0, j = selected.length; i < j; i++) {
      if (attrs.join(' ').indexOf(selected[i]) !== -1) {
        return true;
      }
    }
    return false;
  },
  parseFilters: function() {
    var matched = [],
      selected;
    fabricFilter.showAll = true;
    fabricFilter.attrGroups.each(function(i) {
      selectedAttr = [];
      selected = $(this).find('.filter-key.selected');
      if (selected.length) {
        if ($(this).attr('data-filter-type') !== 'price') {
          fabricFilter.showAll = false;
          selected.each(function(i) {
            selectedAttr.push($(this).attr('data-value'));
          });
          matched.push(selectedAttr);
        }
      }
    });
    return matched;
  },
  sortByPrice: function(items, sortOrder) {
    sortOrder = sortOrder || 'ascending';
    items.sort(function(a, b) {
      var aPrice = a.attr('data-price'),
        bPrice = b.attr('data-price');
      if (aPrice && bPrice) {
        if (sortOrder === 'ascending') {
          return aPrice - bPrice;
        } else {
          return bPrice - aPrice;
        }
      }
    });
    return items;
  },
  updateAttributeStats: function(selectedArr, attrStats) {
    var reset = {},
      flatSelected = [].concat.apply([], selectedArr);
    for (var i = 0; i < fabricFilter.itemAttrs.length; i++) {
      var selected = [];
      for (var j = 0; j < fabricFilter.itemAttrs[i].length; j++) {
        for (var k = 0; k < flatSelected.length; k++) {
          if (fabricFilter.itemAttrs[i][j] === flatSelected[k]) {
            selected.push(j);
          }
        }
      }
      if (selected.length) {
        for (var attr in attrStats) {
          if (attrStats.hasOwnProperty(attr)) {
            for (var l = 0; l < selected.length; l++) {
              if (!reset[attr] && (fabricFilter.filterMappings[fabricFilter.itemAttrs[i][selected[l]]] !== fabricFilter.filterMappings[attr])) {
                attrStats[attr] = 0;
                reset[attr] = true;
              }
            }
          }
        }
        for (var j = 0, jlen = fabricFilter.itemAttrs[i].length; j < jlen; j++) {
          attrStats[fabricFilter.itemAttrs[i][j]]++;
        }
      }
    }
    return attrStats;
  },
  checkSingleFilter: function() {
    var selectedArr = fabricFilter.parseFilters(),
      selectedArrSize = selectedArr.length;
    if (selectedArrSize === 1) {
      return fabricFilter.filterMappings[selectedArr[0][0]];
    }
    return -1;
  },
  isSelected: function(key, selectedArrFlat) {
    return (selectedArrFlat.indexOf(key) !== -1);
  },
  isInSingleDropdown: function(key, column) {
    if (column !== -1) {
      if (fabricFilter.filterMappings[key] === column) {
        return true;
      }
    }
    return false;
  },
  ieStyleSelections: function() {
    var remove;
    fabricFilter.keys.each(function(item) {
      remove = item.next('.filt-item-label').one('.icon-remove-item');
      if (item.get('checked')) {
        remove.css('display', 'block');
      } else {
        remove.css('display', 'none');
      }
    });
  },
  displayItems: function(items) {
    var x, y;
    for (var i = 0, j = items.length; i < j; i++) {
      fabricFilter.displayItem(items[i]);
    }
  },
  displayItem: function(item) {
    if (fabricFilter.filtersInited && !item.hasClass('list-item-move')) {
      item.addClass('list-item-move');
    }
    item.css('display', 'block');
  },
  hideItems: function(items) {
    var transformStyle, x, y, pos;
    for (var i = 0, j = items.length; i < j; i++) {
      fabricFilter.hideItem(items[i]);
    }
  },
  hideItem: function(item) {
    item.css('display', 'none');
  },
  showEmptyState: function() {
    var selectedArr = fabricFilter.parseFilters(),
      emptyState = $('#filt-emptystate'),
      emptyStr = '';
    for (var i = 0; i < selectedArr.length; i++) {
      if (selectedArr[i].length > 1) {
        emptyStr += selectedArr[i].slice(0, selectedArr[i].length - 1).join(', ');
        emptyStr += ' and ' + selectedArr[i][selectedArr[i].length - 1];
      } else if (selectedArr[i].length) {
        emptyStr += selectedArr[i][0];
      }
      if (i < selectedArr.length - 1) {
        emptyStr += ', ';
      }
    }
    emptyState.find('.filt-emptystate-selectedfilters').html(emptyStr);
    emptyState.removeClass('hide');
    $('.color-block .apply-button').addClass('hide');
  },
  hideEmptyState: function() {
    $('#filt-emptystate').addClass('hide');
    $('.color-block .apply-button').removeClass('hide');
  }
};
